import { find as _find } from 'lodash';

class LoginControllerBase {
  constructor($location, $state, $stateParams, authService, appConfig, pushService, angularAuth0, enums) {
          
    this.$state = $state;
    this.$location = $location;
    this.$stateParams = $stateParams;
    this.authService = authService;
    this.appConfig = appConfig;
    this.pushService = pushService;
    this.angularAuth0 = angularAuth0;
    this.enums = enums;

    this.loginType = '';
    this.status = "";
    this.errorMessage = "";

    this.loginData = {
      email: "",
      password: ""
    }
  }

  initialize() {
    console.log('Use Auth0', this.appConfig.useAuth0);

    //OAuth Integrations with External Providers
    if (this.$location.search().code) {
      const state = JSON.parse(this.$location.search().state);

      if (!state.provider) {
        this.$state.go('enquiryEditCode', {enquiryId: state.enquiryId, action: state.action, code: this.$location.search().code});
      }
      else if (state.provider === 'mazda') {
        this.status = "UserAuthorizing";
        const state = JSON.parse(this.$location.search().state);
        
        this.authService.mazdaLoginBackend(this.$location.search().code, state.stateName, state.stateParams);
      }
      
      return;
    }

    if (this.appConfig.useAuth0){   
      if (!this.redirectIfAlreadyLoggedIn2()){
        if (this.$location.hash()) {
          console.log('$location.hash()', this.$location.hash());
          const hashParams = this.splitHash();

          this.status = "UserAuthorizing";
          if (hashParams.id_token) 
          {            
            //Auth0 Client Side Authentication Validaton
            this.handleAuth0Authentication();
          }        
          else {
            //Auth0 Server Side Authentication Validaton
            this.authorize_Auth0(hashParams.access_token);
          }

          return;
        }
      }
    }
    else {
      if (this.$location.search().code) {
        this.status = "UserAuthorizing";
        this.authorize(this.$location.search().code);
      } else {
        this.redirectIfAlreadyLoggedIn();
      }
    }

    if (this.$stateParams.isAdmin) {
      this.showAdminLogin();
    }
  }

  externalLogin() {      
    const state = this.$location.search().state || '';
    if (state){
      window.sessionStorage.setItem('redirectState', state);
    }
    if(this.appConfig.useAuth0){
      this.angularAuth0.authorize({
        redirectUri: this.appConfig.oauthCallbackUrl
      });
    }
    else{
      const redirectUri = location.protocol + '//' + location.host + '/login';      
      const msSigninUri = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${this.appConfig.msClientId}&scope=openid profile offline_access User.Read email&response_type=code&redirect_uri=${redirectUri}`;
      window.location = msSigninUri;
    }
  }

  externalLogin2() {      
    const redirectUri = location.protocol + '//' + location.host + '/login';      
    const auth0SigninUri = `https://${this.appConfig.auth0.domain}/authorize?response_type=token&client_id=${this.appConfig.auth0.clientId}&connection=&redirect_uri=${this.appConfig.oauthCallbackUrl}&scope=openid profile email`
    window.location = auth0SigninUri;
  }  

  handleAuth0Authentication() {
    console.log('handleAuth0Authentication')
    var loginCtrl = this;

    this.angularAuth0.parseHash((err, authResult) => {      
      console.log('parseHash', authResult);
      if (authResult && authResult.accessToken && authResult.idToken) {        
        this.authorize(authResult.idTokenPayload.email);
      }
      else{
        alert(`There was an error logging in. Following are the error details.\nError Code: ${err.error}\nError Description: ${err.errorDescription}\n\n The system will now make an attempt to resolve the issue, after which you can try to login again`);
        this.authService.logOut();
      }
    });  
  }

  handleAuth0AuthenticationServer() {
    console.log('handleAuth0Authentication')
    var loginCtrl = this;

    this.angularAuth0.parseHash((err, authResult) => {      
      console.log('parseHash', authResult);
      if (authResult && authResult.accessToken && authResult.idToken) {        
        this.authorize(authResult.idTokenPayload.email);
      }
      else{
        alert(`There was an error logging in. Following are the error details.\nError Code: ${err.error}\nError Description: ${err.errorDescription}\n\n The system will now make an attempt to resolve the issue, after which you can try to login again`);
        this.authService.logOut();
      }
    });  
  }

  authorize(codeOrEmail) {
    var loginCtrl = this;

    this.authService.authorize(codeOrEmail)
      .then(response => {
        this.pushService.init();
        var loc = this.$location;
        const redirectState = this.getRedirectState();

        if (redirectState) {
          const state = JSON.parse(redirectState);

          if (state.entityId) {
            this.authService.updateLocationLogin(state.entityId);
          }

          loginCtrl.$state.go(state.name, state.params);
        }
        else {
          this.redirectToLandingPage();          
        }

        
      })
      .catch(err => {
        this.status = "";
        loginCtrl.$location.url('/login');

        let errors = [];
        for (let key in err.modelState) {
            for (let i = 0; i < err.modelState[key].length; i++) {
                errors.push(err.modelState[key][i]);
            }
        }
        loginCtrl.errorMessage = errors.join(' ');
      });
  }

  authorize_Auth0(accessToken) {
    var loginCtrl = this;

    this.authService.authorize_Auth0(accessToken)
      .then(response => {
        this.pushService.init();
        var loc = this.$location;
        const redirectState = this.getRedirectState();

        if (redirectState) {
          const state = JSON.parse(redirectState);

          if (state.entityId) {
            this.authService.updateLocationLogin(state.entityId);
          }

          loginCtrl.$state.go(state.name, state.params);
        }
        else {
          this.redirectToLandingPage();
        }

        
      })
      .catch(err => {
        this.status = "";
        loginCtrl.$location.url('/login');

        let errors = [];
        for (let key in err.modelState) {
            for (let i = 0; i < err.modelState[key].length; i++) {
                errors.push(err.modelState[key][i]);
            }
        }
        loginCtrl.errorMessage = errors.join(' ');
      });
  }

  redirectIfAlreadyLoggedIn() {
  let loginCtrl = this;

    if (loginCtrl.authService.isLoggedIn()) {
      if (loginCtrl.authService.authData.isAdmin) {
        loginCtrl.$state.go('admin.listEntities');
      }
      else {
        loginCtrl.$state.go('user');
      }
    }

    return false;
  }

  redirectIfAlreadyLoggedIn2() {
    let loginCtrl = this;
  
      if (loginCtrl.authService.isLoggedIn_NoRedirect()) {
        if (loginCtrl.authService.authData.isAdmin) {
          loginCtrl.$state.go('admin.listEntities');
        }
        else {
          this.redirectToLandingPage();
        }
      }
  
      return false;
    }

  login() {
    let loginCtrl = this;

    this.status = 'AdminAuthorizing';

    loginCtrl.authService.login(loginCtrl.loginData).then(response => {
      loginCtrl.redirectIfAlreadyLoggedIn();
    },
    err => {
      this.status = '';

      if (err.status === 404) {
        loginCtrl.errorMessage = 'Invalid Login Details Suppplied';
      }
      else {
      loginCtrl.errorMessage = err.data.message;
      }
    });
  }

  showAdminLogin() {
    this.hideAdminLogin();
    this.loginType = "Admin";
  }

  hideAdminLogin() {
    this.loginData = {
      email: "",
      password: ""
    };

    this.loginType = '';
    this.errorMessage = '';
  }

  getRedirectState() {
    const state = window.sessionStorage.getItem('redirectState');
    window.sessionStorage.removeItem('redirectState');
    return state;
  }

  splitHash() {
    const hash = this.$location.hash();
    let params = {}
    hash.split('&').map(hk => { 
      let temp = hk.split('='); 
        params[temp[0]] = temp[1] 
    });

    return params;
  }

  redirectToLandingPage() {
    switch(this.authService.authData.currentLocation.landingPage) {
      case this.enums.DEFAULT_LANDING_PAGE.WelcomeCentre: 
        this.$state.go('welcomeCentre');
        break;

      case this.enums.DEFAULT_LANDING_PAGE.Dashboard: 
        this.$state.go('dashboard');
        break;              

      case this.enums.DEFAULT_LANDING_PAGE.LeadMonitor_WebEnquiries_Today:
        this.$state.go('leadMonitor', {dataSource: 1, dateRange: this.enums.DATE_RANGE_TYPE.Today});
        break;                            

      case this.enums.DEFAULT_LANDING_PAGE.LeadMonitor_WebEnquiries_ThisWeek:
        this.$state.go('leadMonitor', {dataSource: 1, dateRange: this.enums.DATE_RANGE_TYPE['This Week']});
        break;                            

      case this.enums.DEFAULT_LANDING_PAGE.LeadMonitor_WebEnquiries_LastWeek:
        this.$state.go('leadMonitor', {dataSource: 1, dateRange: this.enums.DATE_RANGE_TYPE['Last Week']});
        break;                            

      case this.enums.DEFAULT_LANDING_PAGE.LeadMonitor_Enquiries_Today:
        this.$state.go('leadMonitor', {dataSource: 2, dateRange: this.enums.DATE_RANGE_TYPE.Today});
        break;                            

      case this.enums.DEFAULT_LANDING_PAGE.LeadMonitor_Enquiries_ThisWeek:
        this.$state.go('leadMonitor', {dataSource: 2, dateRange: this.enums.DATE_RANGE_TYPE['This Week']});
        break;                            

      case this.enums.DEFAULT_LANDING_PAGE.LeadMonitor_Enquiries_LastWeek:                         
      this.$state.go('leadMonitor', {dataSource: 2, dateRange: this.enums.DATE_RANGE_TYPE['Last Week']});
        break;                            
    }    
  }
}

export default LoginControllerBase;



// WEBPACK FOOTER //
// ./client/app/components/login/LoginControllerBase.js